module.exports = new __parcel__URL__("george-harrison.ca124720.jpg").toString();